import { faTrash } from "@fortawesome/pro-solid-svg-icons"
import IconAndTextButton from "../../IconAndTextButton"
import { Button, Checkbox, Flex, Popover, Space, Tooltip } from "antd"
import VSpace from "../../common/VSpace"
import { centsToDollarsDisplay } from "../../displayFormatters"
import { useState } from "react"
import { Invoice } from "../../../domain/invoicing/invoice"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type Props = {
  invoice: Invoice
  controlsDisabled: boolean
  isInvoicePaid: boolean
  isLoading: boolean
  onDelete: (deleteFromQuickBooks: boolean) => void
}

const DeleteInvoiceButton = ({
  invoice,
  controlsDisabled,
  isLoading,
  isInvoicePaid,
  onDelete,
}: Props) => {
  const [popoverVisible, setPopoverVisible] = useState(false)
  const [deleteFromQuickBooks, setDeleteFromQuickBooks] = useState(true)
  const isExported = invoice.qboInvoiceId.length > 0
  

  if (isInvoicePaid) {
    const howToDelete = invoice.invoicingSystem === 'quickBooks'
    ? 'Remove the invoice or payment from QuickBooks to delete this invoice.'
    : 'Remove the payment to delete this invoice.'

    return <Tooltip title={`Paid invoices cannot be deleted. ${howToDelete}`} trigger="hover">
      <Button
        type="primary"
        danger
        disabled
        loading={isLoading}
      >
        <Space>
          <FontAwesomeIcon icon={faTrash} />
          <span>Delete Invoice</span>
        </Space>
      </Button>
    </Tooltip>
  }

  return (
    <Popover
      open={popoverVisible}
      onOpenChange={setPopoverVisible}
      content={
        <VSpace>
          <strong>
            Are you sure you want to delete this {centsToDollarsDisplay(invoice.total)} invoice?
          </strong>
          { isExported && 
            <Checkbox checked={deleteFromQuickBooks} onChange={(e) => setDeleteFromQuickBooks(e.target.checked)}>
              Also delete from QuickBooks
            </Checkbox>
          }
          <Flex justify="end" gap={5}>
            <Button size="small" onClick={() => setPopoverVisible(false)}>
              Cancel
            </Button>
            <Button
              onClick={() => {
                onDelete(deleteFromQuickBooks)
                setPopoverVisible(false)
              }}
              danger
              size="small"
              type="primary"
            >
              Delete
            </Button>
          </Flex>
        </VSpace>
      }
      trigger="click"
      placement="topRight"
    >
      <IconAndTextButton
        type="primary"
        danger
        icon={faTrash}
        text="Delete Invoice"
        disabled={controlsDisabled}
        loading={isLoading}
      />
    </Popover>
  )
}

export default DeleteInvoiceButton
